import { useQuery } from "@tanstack/react-query";
import { fetchCidadesBySearchTerm } from "../cities";

export type SearchTermParam = {
  cidade: string;
  estado?: string;
};

export function useCidadesSearch(searchTerm: SearchTermParam) {
  const query = useQuery({
    queryKey: ["cidades", searchTerm],
    queryFn: async () => fetchCidadesBySearchTerm(searchTerm),
  });

  const response = query?.data;
  const cityList = response?.data?.results ? response?.data?.results : [];

  return {
    cityList,
    ...query,
  };
}
